import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { DropdownList } from 'react-widgets';
import { toastr } from 'react-redux-toastr';
import { useSelector } from 'react-redux';
import { useDataLoader } from 'react-remote-data-hooks';
import api from '../../../../api';
import ErrorMessage from '../../../../components/text/ErrorMessage';
import { Customer, State, useLead } from '../../../../core';

interface FormProps {
  name?: string;
}

const EditSelectField: React.FunctionComponent<{
  error?: string;
  onClose: () => void;
  updateUser: (details: Customer) => void;
  customerDetails?: Customer;
  property: string;
  value?: string|boolean;
  title: string;
  loadData?: () => Promise<any[]>;
  options?: any[];
  searchable?: boolean;
}> = (props) => {
  const { loadData } = props;
  const leadState = useSelector((state: State) => state.lead);
  const { updateLeadDetails } = useLead(api.lead);
  const { data, loading, loaded, reload } = useDataLoader<any[]>(() => {
    if (loadData) {
      return loadData();
    }
  });

  const { control, handleSubmit, errors, watch } = useForm<FormProps>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
  });

  const onSubmit = (updateData?: any) => {
    onUpdate(updateData.name);
  };

  const onUpdate = async (value: string) => {
    const updateData = {
      [props.property]: value,
    };

    try {
      const response = await api.customer.updateCustomer(
        updateData,
        props.customerDetails?._id
      );
      if (leadState?.leadDetails?._id) {
        const leadResponse = await api.lead.getLead(
          leadState?.leadDetails?._id!
        );

        updateLeadDetails(leadResponse?.data);
      }
      props.updateUser(response);
      props.onClose();
      toastr.success('Success', `${props.title} updated successfully`);
    } catch (error) {
      if (error?.response?.data?.message) {
        toastr.error('Error', error?.response?.data?.message);
      }
    }
  };

  const onFieldUpdate = (e: { key: string }) => {
    if (e.key === 'Enter') {
      onUpdate(watch('name') || '');
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="mt-2 d-flex flex-wrap px-4 py-2 border-top border-bottom contact-form-row active align-items-center">
        <div className="col px-2 contact-label font-xs text-gray-500">
          {props.title}
        </div>
        <div className="col px-2 contact-content d-flex align-items-center">
          <Controller
            control={control}
            rules={{
              required: true,
              validate: (value) => {
                return !!value.trim();
              },
            }}
            name={'name'}
            defaultValue={props.value}
            render={({ onChange, value, name }) => (
              <DropdownList
              filter={!!props?.searchable && "contains"}
                value={value}
                defaultValue={value}
                data={data || props.options}
                textField={'name'}
                valueField={'_id'}
                placeholder={props.title}
                onChange={(val) => {
                  onChange(val._id);
                }}
              />
            )}
          />
          {errors.name && (
            <ErrorMessage>{props.title} is required</ErrorMessage>
          )}
        </div>

        <div className="col-12 px-2 mt-1 text-right">
          <button
            type="submit"
            className="btn btn-sm btn-outline-dark mr-2 font-normal"
            onClick={props.onClose}
          >
            Cancel
          </button>
          <button className="btn btn-sm btn-primary font-normal">Save</button>
        </div>
      </div>
    </form>
  );
};

export default EditSelectField;
